// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f1ffc21","455":"aabb2c03"}[chunkId] + ".chunk.js";
};